import * as Actions from 'actions'
import { FILE_TYPE, IMAGES_SOURCES, SOURCE_FILE_TYPES, WS_EVENT_TYPES } from 'enums'
import { selectSourceFilesParams } from 'selectors'
import { isEmpty } from 'lodash'
import * as ActionTypes from '~/actions/ActionTypes'
import { setSourceFilesParams, createMediaFile, requestDeleteFile } from '~/actions/sourceFiles'
import { onlineTestCooldownMs } from '~/constant'
import { createWebSocketClient } from '~/ServerAPI'
import * as AuthToken from '~/cookieServices/AuthToken'


export const WS_CONNECT = 'WS_CONNECT'
export const WS_DISCONNECT = 'WS_DISCONNECT'
export const SET_AUTH_TOKEN_MISSED = 'SET_AUTH_TOKEN_MISSED'
export const WS_SEND_MESSAGE = 'WS_SEND_MESSAGE'

export const sendWebSocketMessage = messageObj => ({
  type: WS_SEND_MESSAGE,
  payload: messageObj,
})

export const socketMiddleware = () => {
  let client = null
  let showOfflineTimeout = null

  return store => next => action => {
    switch (action.type) {
      case WS_CONNECT:
        if (client !== null) {
          client.close()
        }

        client = createWebSocketClient()

        client.onopen = () => {
          const authToken = AuthToken.get()
          const canPlayHevc = !!document.createElement('video').canPlayType('video/mp4; codecs="hvc1.1.6.L93.90"')

          if (authToken === undefined) {
            store.dispatch({ type: SET_AUTH_TOKEN_MISSED, payload: true })
          }

          client.send(JSON.stringify({
            type: WS_EVENT_TYPES.USER_EVENT,
            payload: { authToken, canPlayHevc },
          }))

          if (showOfflineTimeout) {
            clearTimeout(showOfflineTimeout)
            showOfflineTimeout = null
          }

          const state = store.getState()
          if (state.mainView.isOffline) {
            store.dispatch({ type: ActionTypes.SET_IS_OFFLINE, payload: { isOffline: false } })
          }
        }

        client.onmessage = message => {
          let dataFromServer
          try {
            dataFromServer = JSON.parse(message.data)
          } catch (error) {
            console.error('Error parsing incoming WebSocket message:', error)
            return
          }

          switch (dataFromServer.type) {
            case WS_EVENT_TYPES.PING_EVENT:
              try {
                client.send(JSON.stringify({ type: WS_EVENT_TYPES.PONG_EVENT }))
              } catch (error) {
                console.error('Error sending PONG_EVENT:', error)
              }
              break

            case WS_EVENT_TYPES.USER_INFO_EVENT: {
              const profile = dataFromServer.payload
              store.dispatch(Actions.user.updateUserProfile(profile))

              const { imageLibSources } = profile

              const state = store.getState()
              const { source } = selectSourceFilesParams(state, SOURCE_FILE_TYPES.IMAGES)

              if (__CFG__.SOURCE_FILES_TYPES.IMAGES) {
                const imageLib = !isEmpty(imageLibSources)
                  ? imageLibSources[0]
                  : IMAGES_SOURCES.Native

                store.dispatch(setSourceFilesParams(SOURCE_FILE_TYPES.IMAGES, {
                  imageLibSources,
                  source: imageLibSources.includes(source) ? source : imageLib,
                }))
              }
              break
            }

            case WS_EVENT_TYPES.USER_BC_UPLOAD_MEDIA: {
              const fileId = dataFromServer?.payload?.fileId

              if (fileId) {
                store.dispatch(createMediaFile(fileId, FILE_TYPE.UPLOADED, SOURCE_FILE_TYPES.MEDIA))
              }
              break
            }

            case WS_EVENT_TYPES.USER_BC_DELETE_MEDIA: {
              const fileId = dataFromServer?.payload?.fileId
              if (fileId) {
                store.dispatch(requestDeleteFile(fileId, SOURCE_FILE_TYPES.MEDIA, true))
              }
              break
            }
            case WS_EVENT_TYPES.USER_BC_INSTALL_COMPONENT_COMPLETE: {
              store.dispatch(Actions.mainView.showInstallComponentMessage(true))
              break
            }
            default:
              break
          }
        }

        client.onclose = () => {
          setTimeout(() => {
            store.dispatch({ type: WS_CONNECT })
          }, 1000)

          if (!showOfflineTimeout) {
            showOfflineTimeout = setTimeout(() => {
              store.dispatch({ type: ActionTypes.SET_IS_OFFLINE, payload: { isOffline: true } })
            }, onlineTestCooldownMs)
          }
        }
        break

      case WS_SEND_MESSAGE:
        if (client && client.readyState === window.WebSocket.OPEN) {
          try {
            client.send(JSON.stringify(action.payload))
          } catch (error) {
            console.error('Error serializing or sending WebSocket message:', error)
          }
        } else {
          console.warn('Failed to send message, WebSocket is not connected:', action.payload)
        }
        break

      case WS_DISCONNECT:
        if (client !== null) {
          client.close()
          client = null
        }
        break

      default:
        break
    }

    return next(action)
  }
}
